import { Separator } from '@base-ui/react/separator';
import clsx from 'clsx';

import '@repo/sds/components/SDSSeparator/SDSSeparator.scss';

export interface SDSSeparatorProps {
  /**
   * Orientation of the separator
   * @default 'horizontal'
   */
  orientation?: 'horizontal' | 'vertical';
  /**
   * Additional CSS class for styling
   */
  className?: string;
  /**
   * Whether the separator is decorative (ignored by screen readers)
   * @default true
   */
  decorative?: boolean;
}

export function SDSSeparator({ orientation = 'horizontal', className, decorative = true }: SDSSeparatorProps) {
  const separatorProps = decorative ? { 'aria-hidden': true } : {};

  return (
    <Separator
      orientation={orientation}
      className={clsx('SDSSeparator', `SDSSeparator--${orientation}`, className)}
      {...separatorProps}
    />
  );
}
